import { execute } from "../../apiCommandsExecutor";
import {
    CreateTablesRequest,
    CreateTablesResponse,
    TablesCreateTableRequest,
    TablesCreateTableResponse,
    DeleteTableRequest,
    DeleteTableResponse,
    GetTablesRequest,
    GetTablesResponse,
    UpdateTableRequest,
    UpdateTableResponse, UpdateTableExternalIdRequest, UpdateTableExternalIdResponse
} from "./requestsResponses";
import { TablesApiMethods } from "./methods";



export const getTables = async (organizationBranchId: number) => {
    const res = await execute<GetTablesRequest, GetTablesResponse>(TablesApiMethods.getTables, {
        organizationBranchId
    });
    return res.data;
};



export const createTables = async (params: CreateTablesRequest) => {
    const res = await execute<CreateTablesRequest, CreateTablesResponse>(
        TablesApiMethods.createTables,
        params);
    return res.data;
}
export const createTable = async (params: TablesCreateTableRequest) => {
    const res = await execute<TablesCreateTableRequest, TablesCreateTableResponse>(
        TablesApiMethods.createTable,
        params);
    return res.data;
}


export const updateTable = async (params: UpdateTableRequest) => {
    const res = await execute<UpdateTableRequest, UpdateTableResponse>(
        TablesApiMethods.updateTable,
        params);
    return res.data;
}


export const deleteTable = async (params: DeleteTableRequest) => {
    const res = await execute<DeleteTableRequest, DeleteTableResponse>(
        TablesApiMethods.deleteTable,
        params);
    return res.data;
}



export const updateTableExternalId = async (params: UpdateTableExternalIdRequest) => {
    const res = await execute<UpdateTableExternalIdRequest, UpdateTableExternalIdResponse>(
        TablesApiMethods.updateTableExternalId,
        params);
    return res.data;
}

